import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Dropdown({dropdownItems,dropownHandler,dropdownName,className}) {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <div>
        <Menu.Button className={classNames(className,`inline-flex w-full justify-center gap-x-1.5 rounded-md font-medium  px-3 py-1.5 text-sm  text-white shadow-sm ring-1 ring-inset  hover:ring-opacity-75 hover:bg-opacity-75`)}>
          <dropdownName.icon className="w-5 h-5" />
            {dropdownName.name}
          <ChevronDownIcon
            className="w-5 h-5 -mr-1 font-medium text-white"
            aria-hidden="true"
          />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 w-48 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
              {dropdownItems.length > 0 && dropdownItems.map((item,index)=>(
                  <Menu.Item key={index}>
                      {({ active }) => (
                          <button
                              type="button"
                              onClick={()=>dropownHandler(item.name)}
                              className={classNames(
                                  active ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                  "flex w-full text-left px-4 py-2 text-sm"
                              )}
                          >
                              <item.icon className="w-5 h-5 mr-2 text-gray-900" />
                              {item.name}
                          </button>
                      )}
                  </Menu.Item>
              ))}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
